"use client";
import Link from 'next/link';
import { useParams, usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';
import { getCurrentUser, logoutUser } from '@/app/api';
import NotificationBellDropdown from './NotificationBellDropdown';

export default function Header({ dict }: { dict?: any }) {
  const params = useParams();
  const pathname = usePathname();
  const [user, setUser] = useState<any>(null);

  useEffect(() => {
    setUser(getCurrentUser());
  }, []);

  const handleLogout = async () => {
    await logoutUser();
    setUser(null);
    window.location.href = `/${lang}`;
  };

  const lang = (params?.lang as string) || 'fa';
  const targetLang = lang === 'fa' ? 'en' : 'fa';
  const toggleUrl = pathname ? pathname.replace(`/${lang}`, `/${targetLang}`) : `/${targetLang}`;

  const isAdmin = pathname?.includes('/admin');
  const isPanel = pathname?.includes('/panel');

  return (
    <header 
      className="site-header" 
      dir={lang === 'fa' ? 'rtl' : 'ltr'}
      style={{
        backgroundColor: '#ffffff',
        background: '#ffffff',
        opacity: 1,
        backdropFilter: 'none',
        WebkitBackdropFilter: 'none',
        borderBottom: '1px solid #e2e8f0',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
        zIndex: 1000
      }}
    >
<div className="logo-container">
        <Link href={`/${lang}`} className="logo-link">
          <div className="logo-text">
            PASS<span className="logo-highlight">FUND</span>
          </div>
          <span className="logo-subtitle">PROP TRADING</span>
        </Link>
      </div>

      {isAdmin ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: '14px', flexWrap: 'wrap' }}>
          <span style={{ 
            backgroundColor: 'rgba(14, 165, 233, 0.15)', 
            color: '#38bdf8', 
            border: '1px solid rgba(14, 165, 233, 0.35)', 
            padding: '5px 14px', 
            borderRadius: '20px', 
            fontSize: '12px', 
            fontWeight: '800',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px'
          }}>
            <span style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#10b981', display: 'inline-block' }}></span>
            {lang === 'fa' ? 'پنل مدیریت ارشد' : 'Admin Portal'}
          </span>
          <Link href={`/${lang}`} className="nav-link" style={{ fontSize: '13px', opacity: 0.9 }}>
            {lang === 'fa' ? 'مشاهده سایت عمومی' : 'View Website'}
          </Link>
          <Link href={`/${lang}/panel`} className="nav-link" style={{ fontSize: '13px', opacity: 0.9 }}>
            {lang === 'fa' ? 'پنل تریدر' : 'Trader Panel'}
          </Link>
        </div>
      ) : (
        <nav className="header-nav">
          <Link href={`/${lang}`} className="nav-link">
            {dict?.header?.home || (lang === 'fa' ? 'خانه' : 'Home')}
          </Link>
          <Link href={`/${lang}/rules`} className="nav-link">
            {dict?.header?.rules || (lang === 'fa' ? 'قوانین' : 'Rules')}
          </Link>
          <Link href={`/${lang}/education`} className="nav-link">
            {dict?.header?.education || (lang === 'fa' ? 'آموزش' : 'Education')}
          </Link>
          <Link href={`/${lang}/faq`} className="nav-link">
            {dict?.header?.faq || (lang === 'fa' ? 'سوالات متداول' : 'FAQ')}
          </Link>
          <Link href={`/${lang}/contact`} className="nav-link">
            {dict?.header?.contact || (lang === 'fa' ? 'تماس با ما' : 'Contact Us')}
          </Link>
        </nav>
      )}

      <div className="header-actions">
        <NotificationBellDropdown lang={lang} />
        <Link href={toggleUrl} className="btn btn-lang">
          {lang === 'fa' ? 'English (EN)' : 'فارسی (FA)'}
        </Link>
        {user ? (
          <>
            {!isAdmin && (user.role === 'admin' || user.is_admin) && (
              <Link 
                href={`/${lang}/admin`} 
                className="btn btn-ghost" 
                style={{ backgroundColor: '#0284c7', color: '#ffffff', border: '1px solid #0ea5e9', fontWeight: '700' }}
              >
                {lang === 'fa' ? 'پنل ادمین' : 'Admin Panel'}
              </Link>
            )}
            {!isAdmin && (
              <Link href={`/${lang}/panel`} className="btn btn-ghost">
                {lang === 'fa' ? 'پنل کاربری' : 'Dashboard'}
              </Link>
            )}
            <button onClick={handleLogout} className="btn btn-danger-outline">
              {lang === 'fa' ? 'خروج' : 'Logout'}
            </button>
          </>
        ) : (
          <>
            <Link href={`/${lang}/register`} className="btn btn-ghost">
              {lang === 'fa' ? 'ثبت‌نام' : 'Register'}
            </Link>
            <Link href={`/${lang}/login`} className="btn btn-outline">
              {dict?.header?.login || (lang === 'fa' ? 'ورود به پنل' : 'Login')}
            </Link>
          </>
        )}
      </div>
    </header>
  );
}